<template>
  <div>
    <ProSpaceMainLayout>
      <template #nav>
        <template v-if="roleCorrect">
          <ProSpaceNotificationPanel
            :notifications="unreaded"
            :localization="$t"
            isAlert
            @hide="handlerHideNotification"
          >
            <template #buttons="{ notification }">
              <ProSpaceHLayout :gap="5">
                <ProSpaceAction
                  :text="$t('open')"
                  @click="openNotification(notification)"
                />
                <ProSpaceAction
                  v-if="downloadable(notification)"
                  :text="$t('download')"
                  @click="downloadFile(notification.messageData.Result[0].GFID)"
                />
              </ProSpaceHLayout>
            </template>
          </ProSpaceNotificationPanel>
          <ProSpaceAlertMessage
            v-if="showErrorMessageTop"
            style="z-index: 1005"
            :text="errorText"
            :label="errorLabel"
            :rightTextContent="errorRightTextContent"
            @closeHandler="closeHandler"
          />
          <ProSpaceSidebar
            v-if="pageLoaded"
            :service="menuService"
            getMethod="getMenu"
            @redirectTo="toLink"
            @logout="logout"
            @changeLocale="updateLocale"
            @changeTheme="updateTheme"
            @avatar="showUserProfile"
            @name="showUserProfile"
            @loading="setDocumentTitle"
            @clear-storage="handlerClearStorage"
            :supportItem="supportItem"
            :user="user"
            :current-locale="i18nLocale"
            :current-theme="currentTheme"
            :locale-options="localeOptions"
            :currentPath="currentPath"
            :hiddenCounters="['AddressProgram']"
            :theme-txt="$t('sideBarThemeTxt')"
            :language-txt="$t('sideBarLanguageTxt')"
            :logout-txt="$t('sideBarLogoutTxt')"
            :storage-txt="$t('sideBarStorageTxt')"
            ref="sidebar"
          >
            <template #logo="{ collapsed }">
              <svg-icon
                v-if="!collapsed"
                name="sidebar-logo-full"
                :width="135"
                :height="35"
              />
              <svg-icon
                v-else
                name="sidebar-logo-small"
                :width="29"
                :height="32"
              />
            </template>
          </ProSpaceSidebar>
        </template>
      </template>
      <template #center>
        <div style="height: 100vh" v-if="roleCorrect && pageLoaded">
          <slot />
        </div>
        <div v-else class="loading-screen">
          <img class="loading-screen__img-nets" src="./assets/nets.png" />
        </div>
      </template>
      <ProSpaceConfirmDialog :ConfirmationEventBus="ConfirmationEventBus" />
    </ProSpaceMainLayout>
    <ProSpaceUserProfileModal
      v-if="roleCorrect && Object.keys(user).length > 0"
      ref="modalUserProfile"
      v-model="visibleUserProfileModal"
      :confirmTimezone="confirmTimezone"
      :userInfo="userProfileInfo"
      @close="closeUserProfileModal"
      @logout="logout"
      @changeLocale="updateLocale"
      @clear-storage="handlerClearStorage"
      @update:timezone="alertTimezoneModal = true"
    />
    <ProSpaceModal
      v-model="showMessageError"
      :cancelTxt="$t('cancelTxt')"
      is-custom
      transparent
    >
      <ProSpaceMessage
        type="error"
        icon="info"
        :title="$t('businessErrorsMessage')"
        @close="onCloseError"
      >
        <template #body>
          <ProSpaceError
            grid-type="single"
            :body="buisnessErrorMessage"
            :details="buisnessErrors"
            :showDetailsLabel="$t('showErrorDetails')"
            :translates="modalTranslates"
            :titleModal="$t('errors')"
            :title="$t('errors')"
            :cancelText="$t('closeTxt')"
            @close="onCloseError"
          >
          </ProSpaceError>
        </template>
        <template #controls>
          <ProSpaceHLayout justify-content="flex-end">
            <ProSpaceButton
              type="tertiary"
              :label="$t('closeTxt')"
              @click="onCloseError"
            />
          </ProSpaceHLayout>
        </template>
      </ProSpaceMessage>
    </ProSpaceModal>
    <ProSpaceModal
      v-if="!roleCorrect && user.role"
      v-model="showRoleSelection"
      icon="user"
      :title="$t('selectRoleForEnter')"
      :width="400"
      :height="235"
      :withoutClose="true"
      :cancelTxt="false"
      :applyTxt="$t('applyTxt')"
      :disabledApply="!selectRoleModel"
      class="loading-select-role-modal"
      @apply="applyCurrentRoleHandler"
    >
      <ProSpaceDropdown
        v-if="user.role.length > 0"
        v-model="selectRoleModel"
        :options="user.role"
        propLabel="displayName"
        propValue="id"
        :placeholder="$t('selectRole')"
        :label="$t('currentRole')"
      />
      <div v-else class="loading-select-role-modal__text">
        {{ $t("rolesEmpty") }}
      </div>
    </ProSpaceModal>
    <AddressProgramOrderModalPeriod
      v-if="showPeriodModal"
      v-model="showPeriodModal"
      :disabledClose="disabledClose"
    />
    <AddressProgramOrderModalPeriodArchive
      v-if="showPeriodModalArchived"
      v-model="showPeriodModalArchived"
      :disabledClose="disabledCloseArchive"
    />
    <ProSpaceFlashMessage
      v-if="alertTimezoneModal"
      v-model="alertTimezoneModal"
      icon="flash-warning"
      :title="$t('signOut')"
      :cancelTxt="$t('cancelTxt')"
      :applyTxt="$t('applyTxt')"
      :needHideApply="false"
      @apply="confirmTimezone = true"
      @update:modelValue="
        (val) => {
          if (!val) this.cancelChangeTimezone();
        }
      "
    >
      {{ $t("alertChangeTimezone") }}
    </ProSpaceFlashMessage>
    <ProSpaceFlashMessage
      v-if="show403ModalError"
      v-model="show403ModalError"
      icon="flash-warning"
      :title="$t('alertRoleHasChangedTitle')"
      :cancelTxt="$t('cancelTxt')"
      :applyTxt="$t('applyTxt')"
      :needHideApply="false"
      @apply="apply403ModalError"
      @update:modelValue="
        (val) => {
          if (!val) this.$store.commit('errorStore/SET_ERROR403_MODAL', false);
        }
      "
    >
      {{ $t("alertRoleHasChangedTxt") }}
    </ProSpaceFlashMessage>
  </div>
</template>
<style lang="scss">
.loading-select-role-modal {
  margin: 0px !important;
  height: 100%;
  display: flex;
  justify-content: center;
  box-shadow: none;

  &__text {
    text-align: center;
    font-weight: 500;
    font-size: 16;
  }

  .p-dialog-content {
    height: 135px;
    padding-top: 30px;
  }

  .prospace-dropdown {
    .prospace-input-layout__label {
      color: var(--prospace-text-main);
    }
  }
}

.loading-screen {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(180deg, #2c3e50 0%, #4f5c75 100%);
  position: relative;

  .loading-screen__img-nets {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

// перенести в либу
@supports (scrollbar-width: auto) {
  .prospace-sidebar .prospace-scrollbar,
  .p-datatable-wrapper .p-virtualscroller,
  .prospace-block,
  .prospace-modal-wrapper,
  .prospace-filter-panel__chips-hidden .p-chips-multiple-container,
  .p-multiselect-panel .p-multiselect-items-wrapper,
  .p-dropdown-panel .p-dropdown-items-wrapper {
    scrollbar-width: auto;
    scrollbar-color: auto;

    @-moz-document url-prefix() {
      scrollbar-width: thin;
      scrollbar-color: var(--prospace-ui-main-menu-element) transparent;
    }
  }
}
</style>
<script>
import primeVueLocales from "../../Common/utils/primevue-locales/locales.json";
import ProSpaceUserProfileModal from "./modals/ProSpaceUserProfileModal";
import { mapGetters } from "vuex";
import UserInfoApi from "../../../Api/UserInfoApi";
import UserService from "../../../../Application/Services/Security/Security.Frontend/services/UserService";
import { UserService as UserSecService } from "../../../../Application/Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/services/UserService";
import ClaimApi from "../../../Api/ClaimApi";
import ErrorListApi from "../../../Api/ErrorListApi";
import LocalesApi from "../../../Api/LocalesApi";
import SecurityRoleAccessApi from "../../../Api/SecurityRoleAccessApi";
import { notificationsInit } from "../../Common/utils/notifications.js";
import AddressProgramOrderModalPeriod from "../../../Services/AddressProgram/AddressProgram.Frontend/views/AddressProgramOrders/components/AddressProgramOrderModalPeriod.vue";
import AddressProgramOrderModalPeriodArchive from "../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/AddressProgramOrders/components/AddressProgramOrderModalPeriod.vue";
import { computed } from "vue";
import {
  removeToken,
  removeRefreshToken,
  removeRedirectUrl,
} from "../../Common/utils/auth";

import {
  ProSpaceAlertMessage,
  ProSpaceFlashMessage,
  ProSpaceSidebar,
  ProSpaceMainLayout,
  ProSpaceMessage,
  ProSpaceModal,
  ProSpaceError,
  ProSpaceHLayout,
  ProSpaceButton,
  ProSpaceNotificationPanel,
  ProSpaceDropdown,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import MenuService from "../services/MenuService";
import { FileService } from "../services/FileService.js";
import store from "@common/store";
import accessMixin from "@common/utils/elementAccess/accessMixin";
export default {
  mixins: [accessMixin],
  components: {
    ProSpaceAlertMessage,
    ProSpaceFlashMessage,
    ProSpaceSidebar,
    ProSpaceMainLayout,
    ProSpaceUserProfileModal,
    ProSpaceMessage,
    ProSpaceModal,
    ProSpaceError,
    ProSpaceHLayout,
    ProSpaceButton,
    ProSpaceNotificationPanel,
    ProSpaceDropdown,
    AddressProgramOrderModalPeriod,
    AddressProgramOrderModalPeriodArchive,
    ProSpaceAction,
  },
  data() {
    return {
      currentPath: window.location.pathname,
      showErrorMessageTop: false,
      showRoleSelection: true,
      pageLoaded: false,
      errorText: "",
      errorLabel: "Error",
      errorRightTextContent: "Close",
      user: {},
      menuService: new MenuService(),
      userService: new UserService(),
      userInfoApi: new UserInfoApi(),
      errorListApi: new ErrorListApi(),
      securityRoleAccessApi: new SecurityRoleAccessApi(),
      localesApi: new LocalesApi(),
      claimApi: new ClaimApi(),
      usersSecService: new UserSecService(),
      fileService: new FileService(),
      localeOptions: [],
      i18nLocale:
        localStorage.getItem("locale") != null
          ? localStorage.getItem("locale").toUpperCase()
          : this.$i18n.locale.toUpperCase(),
      visibleUserProfileModal: false,
      showMessageError: false,
      buisnessErrors: [],
      buisnessErrorMessage: "",
      excludeNotificationTitles: [],
      currentRole: false,
      selectRoleModel: false,
      primeVueLocales,
      disabledClose: false,
      disabledCloseArchive: false,
      needSelectPeriod: false,
      showedNotification: [],
      localAccess: null,
      periodUpdated: false,
      timeZoneId: null,
      alertTimezoneModal: false,
      confirmTimezone: false,
      userProfileInfo: {
        user: null,
        currentLocale: null,
        localeOptions: null,
      },
    };
  },
  provide() {
    return {
      injectedUserRole: computed(() => this.user?.position?.systemName),
    };
  },
  created() {
    this.getSecurityRoleAccess();
    this.$store.dispatch("marsPeriodStore/setMarsPeriod");
    this.$store.dispatch("marsPeriodStoreArchived/setMarsPeriod");
    if (this.currentPeriod && Object.keys(this.currentPeriod).length > 0) {
      this.disabledClose = false;
    }
    if (this.currentPeriodArchived && Object.keys(this.currentPeriodArchived).length > 0) {
      this.disabledCloseArchive = false;
    }
  },
  mounted() {
    this.getUserInfo();
    this.$store.dispatch("marsPeriodStore/setHandler", () => {
      this.$store.dispatch("maapNotifications/recalculateMenu");
    });
    this.$store.dispatch("errorStore/setBuisnessErrorHandler", (errors) => {
      let errorCount = errors.filter((e) => e.type === "Error").length;
      let warningCount = errors.filter((e) => e.type === "Warning").length;
      let infoCount = errors.filter((e) => e.type === "Info").length;
      this.buisnessErrorMessage = `${this.$t(
        "errors"
      )} - ${errorCount}; ${this.$t("warnings")} - ${warningCount}; ${this.$t(
        "infos"
      )} - ${infoCount};`;
      errors.forEach((e) => {
        let errorInfo = this.errorCodes.find((c) => c.code == e.code);
        if (errorInfo) e.message = errorInfo.message;
      });
      this.buisnessErrors = errors;
      this.showMessageError = true;
    });
    this.getLocales();
    this.setPrimeVueLocale();
    this.getSecurityRoleAccess();
    this.getSecurityClaimsCache();
    this.$router.beforeEach(this.handlerRouterBeforeEach);
  },
  methods: {
    async handlerRouterBeforeEach(to) {
      await this.loadRoleAccess(to.name);
      this.setActiveMenuitem(to);
      this.setDocumentTitle(to);
    },
    setActiveMenuitem(to) {
      this.currentPath = to.path;
    },
    setDocumentTitle(to) {
      if (!this.$refs.sidebar) {
        return;
      }
      let menuitem;
      if (to) {
        menuitem = to.query.menuitem || btoa(to.path);
      } else {
        const search = new URLSearchParams(document.location.search);
        menuitem = search.get("menuitem") || btoa(document.location.pathname);
      }
      const array = [];
      this.$refs.sidebar.menuList.forEach((i) => {
        if (i.path !== "") {
          array.push(i);
        }
        if (i.children) {
          array.push(...i.children);
        }
      });
      const item = array.find((i) => btoa(i.path) === menuitem);
      if (!item) {
        document.title = "MAAP";
        return;
      }
      const language = JSON.parse(item.language);
      const title = language[this.i18nLocale] || "MAAP";
      document.title = `MAAP - ${title}`;
    },
    downloadable(notification) {
      if (notification && notification.messageData) {
        if (Array.isArray(notification.messageData.Result)) {
          if (notification.messageData.Result[0].ResultType == "File") {
            return true;
          }
        }
      }
      return false;
    },
    downloadFile(gfid) {
      //Первый запрос получает токен необходимый для скачивания файла.
      this.fileService.getFileToken(gfid).then((response) => {
        if (response != null) {
          //второй запрос скачивает файл
          this.fileService
            .downloadFile(response.data.token)
            .then((fileResponse) => {
              //TODO: check error
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(fileResponse.data);
              let name = fileResponse.headers["content-disposition"]
                .split(";")
                .find((n) => n.includes("filename="))
                .replace("filename=", "")
                .trim();
              link.download = decodeURI(name).replace("%2b", "+");
              link.click();
            });
        } else {
          //TODO: ERROR
        }
      });
    },
    openNotification(notification) {
      if (notification && notification.messageData) {
        if (notification.messageData.Title == "Background tasks") {
          let path = "/scheduler/userTasks";
          let parameters = null;
          const id = notification.messageData.Record.Id;
          if (id && id !== "userTaskNewStaticId") {
            parameters = {
              openResult: notification.messageData.Record.Id,
            };
          }
          this.toLink(path, parameters);
          return;
        }
        if (
          [].includes(notification.messageData.Title) &&
          notification.messageData.Record.Id
        ) {
          let path = "";
          path = path + notification.messageData.Record.Id;
          this.toLink(path);
          return;
        }
        if (notification.messageData.Title === "AddressProgram") {
          this.toLink("/addressprogram/addressprogramorders");
          return;
        }
        if (notification.messageData.Title === "OrderMarsStatus") {
          this.toLink("/addressprogram/dashboard");
          return;
        }
      } else if (notification && notification.groupType) {
        const distTypes = {
          backgroundTask: "/scheduler/userTasks",
          orderStatusNotification: "/addressprogram/addressprogramorders",
          orderNewStatus: "/addressprogram/addressprogramorders",
          publishedOrderMarsStatus: "/addressprogram/addressprogramorders",
          createdOrderMarsStatus: "/addressprogram/addressprogramorders",
          approvedOrderMarsStatus: "/addressprogram/addressprogramorders",
          completedOrderMarsStatus: "/addressprogram/addressprogramorders",
        };
        const path = distTypes[notification.groupType];
        this.toLink(path);
        return;
      }
    },
    applyCurrentRoleHandler() {
      const role = this.user.roles.find(
        (role) => role.id == this.selectRoleModel
      );
      localStorage.setItem("userRole", JSON.stringify(role));
      this.currentRole = role;
      this.user.position = this.currentRole;
      if (Object.keys(this.currentPeriod).length === 0) {
        this.$store.commit("marsPeriodStore/SET_PERIODMODALSTATE", true);
      }
    },
    onCloseError() {
      this.showMessageError = false;
      this.buisnessErrorMessage = "";
      this.buisnessErrors = [];
    },
    closeUserProfileModal() {
      this.visibleUserProfileModal = false;
    },
    showUserProfile() {
      this.userProfileInfo.user = this.user;
      this.userProfileInfo.currentLocale = this.i18nLocale;
      this.userProfileInfo.localeOptions = this.localeOptions;
      this.visibleUserProfileModal = true;
    },
    updateLocale(locale) {
      localStorage.setItem("locale", locale.toLowerCase());
      this.$i18n.locale = locale.toLowerCase();
      this.i18nLocale = this.$i18n.locale.toUpperCase();
      if (this.$refs.modalUserProfile) {
        this.$refs.modalUserProfile.currentLocale = this.i18nLocale;
      }
      this.setPrimeVueLocale();
      this.setDocumentTitle();
      this.loadErrorCodes(this.$i18n.locale, this);
    },
    setBodyClassTheme(theme) {
      const secondTheme = theme === 'light' ? 'dark' : 'light'
      document.body.classList.remove(`theme-${secondTheme}`)
      document.body.classList.add(`theme-${theme}`)
    },
    updateTheme(theme) {
      this.setBodyClassTheme(theme);
      this.$store.dispatch("userinfoStore/setTheme", theme);
    },
    handlerClearStorage() {
      const ignoredKeys = [
        "SecurityAdmin-Refresh-Token",
        "SecurityAdmin-Redirect-Url",
        "SecurityAdmin-Access-Token",
      ];
      Object.keys(localStorage)
        .filter((key) => !ignoredKeys.includes(key))
        .forEach((key) => localStorage.removeItem(key));
      window.location.reload();
    },
    setPrimeVueLocale() {
      const locale =
        localStorage.getItem("locale") != null
          ? localStorage.getItem("locale").toUpperCase()
          : this.$i18n.locale.toUpperCase();
      this.$primevue.config.locale = this.primeVueLocales[locale];
    },
    logout() {
      this.userService.logout().then((res) => {
        removeToken();
        removeRefreshToken();
        removeRedirectUrl();
        if (res.data) window.location.href = res.data;
        else location.href = "/security/login";
      });
    },
    closeHandler() {
      this.showErrorMessageTop = false;
    },
    toLink(path, parameters) {
      let item = { ...this.getItem(path) };
      const routerPush = () => {
        this.currentPath = path;
        this.$router.push({
          path: path,
          query: parameters,
        });
      };
      // для АП необходимо вызывать прочтение нотификаций из стора maapNotifications
      if (item.title === "AddressProgram") {
        this.$store
          .dispatch("maapNotifications/updateReaded", item)
          .then(() => routerPush());
      } else if (!this.excludeNotificationTitles.includes(item.title)) {
        item.readed = true;
        this.$store
          .dispatch("notifications/updateReaded", item)
          .then(() => routerPush());
      } else routerPush();
    },
    getItem(path, root) {
      root = root || this.$refs.sidebar.menuList;
      for (const menuItem of root) {
        if (menuItem.path === path) {
          return menuItem;
        }
        if (menuItem.children.length > 0) {
          let c = this.getItem(path, menuItem.children);
          if (c) return menuItem;
        }
      }
    },
    getLocales() {
      this.localesApi.get().then((res) => {
        this.localeOptions = res.data;
      });
    },
    getUserInfo() {
      this.pageLoaded = false;
      const me = this;
      return me.userInfoApi
        .get()
        .then((res) => {
          if (Object.keys(res.data).length > 0) {
            me.$store.dispatch("userinfoStore/setUserinfo", res.data.data);
            for (const k in res.data.data) me.user[k] = res.data.data[k];
            me.user.name =
              res.data.data.firstName + " " + res.data.data.lastName;

            me.$i18n.locale =
              localStorage.getItem("locale") || this.$i18n.locale.toUpperCase();
            if (me.$i18n.locale) {
              me.loadErrorCodes(me.$i18n.locale.toLowerCase(), me, true);
            }

            const role = JSON.parse(localStorage.getItem("userRole"));
            me.currentRole = role;
            me.user.position = me.currentRole;
            if (
              (!me.currentRole && me.user.role) ||
              me.currentRole != me.user.role
            ) {
              me.currentRole = me.user.role;
              localStorage.setItem("userRole", JSON.stringify(me.currentRole));
              me.user.position = me.currentRole;
            }
            const timeZoneId = JSON.parse(localStorage.getItem("timeZoneId"));
            me.timeZoneId = timeZoneId;
            if (!me.timeZoneId || me.user.timeZoneId !== me.timeZoneId) {
              me.timeZoneId = me.user.timeZoneId;
              localStorage.setItem("timeZoneId", JSON.stringify(me.timeZoneId));
            }
          }
          notificationsInit().then((loadedNotifications) => {
            let lastDate = null;
            if (loadedNotifications && loadedNotifications.length > 0) {
              lastDate = loadedNotifications.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              })[0].date;
            }
            me.userInfoApi.sendPending(lastDate);
          });
          return this.user;
        })
        .finally(() => {
          me.pageLoaded = true;
          return this.user;
        });
    },
    setLocalMessage(me, e) {
      let errorInfo = me.errorCodes.find((c) => c.code == e.code);
      if (errorInfo) e.message = errorInfo.message;
      if (e.innerException) me.setLocalMessage(me, e.innerException);
    },
    setExceptionText(me, e) {
      me.errorText += `${e.code} - ${e.message}; `;
      if (e.innerException) me.setExceptionText(me, e.innerException);
    },
    loadErrorCodes(locale, me, rw = false) {
      me.errorListApi.get(locale).then((res) => {
        if (rw) {
          me.$store.dispatch("errorStore/setHandler", (error) => {
            me.errorText = "";
            if (Array.isArray(error?.errors)) {
              if (me.errorCodes) {
                error.errors.forEach((e) => {
                  me.setLocalMessage(me, e);
                });
              }
              error.errors.forEach((e) => {
                me.setExceptionText(me, e);
                if (e.traceId) me.errorText += `TraceId: ${e.traceId}; `;
                if (e.spanId) me.errorText += `SpanId: ${e.spanId}`;
              });
              me.showErrorMessageTop = true;
            }
          });
        }
        me.$store.dispatch("errorStore/setErrorCodes", [...res.data.data]);
      });
    },
    getSecurityRoleAccess() {
      const me = this;
      me.securityRoleAccessApi.getSecurityRoleAccess().then((res) => {
        me.$store.dispatch("securityRoleAccess/clear");
        if (Object.keys(res.data).length > 0) {
          const accesses = JSON.parse(res.data.data);
          Object.entries(accesses).forEach(([key, value]) => {
            me.$store.dispatch("securityRoleAccess/addAccess", [key, value]);
          });
        }
      });
    },
    getSecurityClaimsCache() {
      let me = this;
      let hash = null;
      const claimsCache = JSON.parse(localStorage.getItem("claimsCache"));
      if (claimsCache && claimsCache.hash) {
        hash = claimsCache.hash;
      }
      me.claimApi.checkClaimCache(hash).then((res) => {
        if (
          res &&
          res.data &&
          res.data.success &&
          res.data.data &&
          res.data.data.claimValues
        ) {
          localStorage.setItem("claimsCache", JSON.stringify(res.data.data));
        }
      });
    },
    handlerHideNotification(notification) {
      this.showedNotification.push(notification.messageId);
      if (notification.isFront) {
        this.$store.dispatch(
          "notifications/deleteFrontNotification",
          notification
        );
      }
    },
    groupNotifications(notifications) {
      const unreadNotifications = notifications.filter(
        (n) => !this.showedNotification.includes(this.getUnicIdNotification(n))
      );
      const unreadTypes = [];
      unreadNotifications.forEach((n) => {
        const type = n.messageData.NotificationType;
        if (!unreadTypes.includes(type)) {
          unreadTypes.push(type);
        }
      });

      const groupType = {};
      notifications.forEach((n) => {
        const type = n.messageData.NotificationType;
        if (!unreadTypes.includes(type)) {
          return;
        }
        if (!groupType[type]) {
          groupType[type] = [];
        }
        if (type) {
          this.showedNotification.push(this.getUnicIdNotification(n));
        }
        groupType[type].push(n);

        // изменение статуса о прочтении нотификации по обновлению периода (чтобы уведомление не показывалось повторно)
        if (n.messageData.Title === "OrderMarsStatus") {
          this.$store.dispatch("notifications/updateReadedRecord", {
            title: n.messageData.Title,
            id: n.messageData.Record.Id,
          });
        }
      });
      let undefinedType = [];
      const strUndefined = "undefined";
      if (groupType[strUndefined]) {
        undefinedType = groupType[strUndefined];
        delete groupType[strUndefined];
      }

      let fields = { period: this.currentPeriod.name };
      let result = [];
      Object.entries(groupType).forEach(([type, values]) => {
        const count = this.getCounter(values, true);
        if (count) {
          let notification = null;
          const unreadInfo = values[0].messageData.UnreadInfo;
          const hasUnread = Array.isArray(unreadInfo) && unreadInfo.length > 0;
          if (count > 1 || hasUnread) {
            Object.assign(fields, this.makeAdditionalFields(type, values));
            const id = result.length + type;
            const title = this.$t(type, fields) + " - " + count;
            const messageId = title;
            const groupType = type;
            notification = { id, title, groupType, messageId };
          } else if (values.length > 1) {
            notification =
              values.find((i) => i.messageData.UnreadCount > 0) || null;
          } else {
            notification = values[0];
          }
          if (notification) {
            const unicId = this.getUnicIdNotification(notification);
            this.showedNotification.push(unicId);
            result.push(notification);
          }
        }
      });
      undefinedType.forEach((n) => {
        const unicId = this.getUnicIdNotification(n);
        if (!this.showedNotification.includes(unicId)) {
          result.push(n);
          this.showedNotification.push(unicId);
        }
      });

      const ids = this.unreaded?.map((i) => i.id) || [];
      result = result.filter((i) => !ids.includes(i.id));
      return result;
    },
    makeAdditionalFields(type, notifications) {
      if (type === "orderStatusNotification") {
        if (
          notifications?.length > 0 &&
          notifications[0]?.messageData?.Record?.Status
        ) {
          return {
            status: this.$t(
              `order_${notifications[0].messageData.Record.Status}`
            ),
          };
        }
        return {};
      } else if (
        [
          "publishedOrderMarsStatus",
          "createdOrderMarsStatus",
          "approvedOrderMarsStatus",
          "completedOrderMarsStatus",
        ].includes(type)
      ) {
        if (
          notifications?.length > 0 &&
          notifications[0]?.messageData?.UnreadInfo &&
          notifications[0]?.messageData?.UnreadInfo[0]?.Status
        ) {
          let result = {
            status: this.$t(
              `order_${notifications[0].messageData.UnreadInfo[0].Status}`
            ),
            agency: "",
          };
          let a = notifications
            .flatMap((x) =>
              x.messageData.UnreadInfo.filter((ui) => ui.Aditional).flatMap(
                (ui) => ui.Aditional
              )
            )
            .filter((x) => x);
          a = [...new Map(a.map((x) => [x.AgencyId, x])).values()];
          if (a.length === 1) result.agency = ", " + a[0].AgencyName;
          return result;
        }
        return {};
      }
      return {};
    },
    getUnicIdNotification(n) {
      return `${n.id}-${n.messageId}-${n.periodId}`;
    },
    updatePeriod(fromRoute = false) {
      if (!this.periodUpdated && !fromRoute) {
        this.$store.dispatch(
          "marsPeriodStore/updateCurrentPeriod",
          this.currentPeriod?.id
        );
        this.periodUpdated = true;
      } else if (fromRoute) {
        this.$store.dispatch(
          "marsPeriodStore/updateCurrentPeriod",
          this.currentPeriod?.id
        );
      }
    },
    cancelChangeTimezone() {
      this.confirmTimezone = {};
      this.alertTimezoneModal = false;
    },
    apply403ModalError() {
      this.$store.commit("errorStore/SET_ERROR403_MODAL", false);
      window.location.href = "/addressprogram/dashboard";
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      errorCodes: "errorStore/getErrorCodes",
      currentTheme: "userinfoStore/getTheme",
      lastChangedNotification: "maapNotifications/lastChanged",
      notificationMessages: "maapNotifications/notificationMessages",
      getCounter: "notifications/getCounter",
      currentPeriod: "marsPeriodStore/getMarsPeriod",
      showPeriodModal: "marsPeriodStore/getPeriodModalState",
      show403ModalError: "errorStore/getError403Modal",
      currentPeriodArchived: "marsPeriodStoreArchived/getMarsPeriod",
      showPeriodModalArchived: "marsPeriodStoreArchived/getPeriodModalState",
    }),
    modalTranslates() {
      const me = this;
      return {
        type: me.$t("type"),
        date: me.$t("date"),
        description: me.$t("description"),
      };
    },
    unreaded() {
      let unread = this.notificationMessages.filter(
        (n) => n.readed === false || n.isFront
      );
      unread = unread.filter(
        (n) => !["Deleted"].includes(n.messageData.NotificationType)
      );
      unread = this.groupNotifications(unread);
      return unread;
    },
    supportItem() {
      let supportItems = [];
      // if (this.checkLocalAccess("requestAccess-MenuItem"))
      //   supportItems.push({
      //     icon: "user-plus",
      //     title: this.$t("requestAccess"),
      //     f: () => {
      //       this.visibleReqCreateUserModal = true;
      //     },
      //   });

      // supportItems.push({
      //   icon: "support",
      //   title: this.$t("support"),
      //   f: () => {
      //     this.visibleSupportModal = true;
      //   },
      // });

      return supportItems;
    },
    roleCorrect() {
      return true;
    },
  },
  watch: {
    lastChangedNotification: {
      handler(val) {
        if (val) {
          if (!this.$refs.sidebar) return;
          let mi = this.$refs.sidebar.menuList.find(
            (i) => val.messageData && i.title === val.messageData.Title
          );
          if (mi) mi.notificationCount = val.counter;
        }
      },
    },
    "$i18n.locale": {
      handler(val) {
        this.updateLocale(val.toUpperCase());
      },
    },
    currentRole: {
      handler(val) {
        if (val && Object.keys(this.currentPeriod).length === 0) {
          this.$store.commit(
            "marsPeriodStore/SET_PERIODMODALSTATE",
            Object.keys(val).length > 0
          );
        }
      },
      immediate: true,
    },
    currentPeriod: {
      handler(val) {
        this.disabledClose = !Object.keys(val).length > 0;
        this.updatePeriod();
      },
      immediate: true,
    },
    "$route.path": {
      handler: function (val, oldVal) {
        if (val !== oldVal && oldVal.trim() !== "/") {
          this.updatePeriod(true);
        }
      },
    },
    currentTheme: {
      handler: function (val) {
        this.setBodyClassTheme(val);
      },
      immediate: true
    }
  },
};
</script>
